import { ThemeUIStyleObject } from 'theme-ui';

export const transitions: ThemeUIStyleObject = {
  '@keyframes growHorizontal': {
    from: { transform: 'scaleX(0)' },
    to: { transform: 'scaleY(100%)' },
  },
  '.hamburguerMenu': { display: 'none' },
  '.hamburguerMenu-enter,\n.hamburguerMenu-appear': {
    display: 'block',
    transform: 'scale(0.7)',
    opacity: 0,
  },
  '.hamburguerMenu-enter-active,\n.hamburguerMenu-appear-active': {
    transform: 'translateX(0)',
    transition: 'opacity 150ms, transform 150ms',
    transformOrigin: 'right top',
    opacity: 1,
  },
  '.hamburguerMenu-enter-done,\n.hamburguerMenu-appear-done': {
    display: 'block',
  },
  '.hamburguerMenu-exit': {
    display: 'block',
    transform: 'scale(1)',
    opacity: 1,
  },
  '.hamburguerMenu-exit-active': {
    transform: 'scale(0.7) translateX(0)',
    transition: 'opacity 150ms, transform 150ms',
    display: 'block',
    opacity: 0,
    transformOrigin: 'right top',
  },
  '.hamburguerMenu-exit-done': { display: 'none' },
  '.modal-enter,\n.modal-appear': { opacity: 0, transform: 'scale(0.8)' },
  '.modal-enter-active,\n.modal-appear-active': {
    opacity: 1,
    transform: 'translateX(0)',
    transition: 'opacity 150ms, transform 150ms',
    transitionDelay: '0',
  },
  '.modal-exit': { opacity: 0 },
  '.modal-exit-done': { opacity: 0, display: 'none' },
  '.modal-exit-active': {
    opacity: 0,
    transform: 'scale(100)',
    transition: 'opacity 150ms, transform 150ms',
    transitionDelay: '0',
  },
  '.overlayAnimation-enter .overlayAnimation:not(.not-released),\n.overlayAnimation-appear .overlayAnimation:not(.not-released)':
    {
      opacity: 0,
    },
  '.overlayAnimation-enter-active .overlayAnimation:not(.not-released),\n.overlayAnimation-appear-active .overlayAnimation:not(.not-released)':
    {
      opacity: 1,
      transition: 'opacity 150ms',
    },
  '.overlayAnimation-exit': { opacity: 1 },
  '.overlayAnimation-exit-active': { opacity: 0, transition: 'opacity 150ms' },
  '.fromRight-enter,\n.fromRight-appear': { transform: 'translateX(550px)' },
  '.fromRight-enter-active,\n.fromRight-appear-active': {
    transition: 'transform 150ms',
    transform: 'translateX(0)',
  },
  '.fromRight-exit': { transform: 'translateX(0)' },
  '.fromRight-exit-active': {
    transition: 'transform 150ms',
    transform: 'translateX(550px)',
  },
  '.notification-enter,\n.notification-appear': {
    opacity: 0,
    transform: 'scale(0.8)',
  },
  '.notification-enter-active,\n.notification-appear-active': {
    opacity: 1,
    transform: 'translateX(0)',
    transition: 'opacity 150ms, transform 150ms',
    transitionDelay: '0',
  },
  '.notification-exit': { opacity: 1 },
  '.notification-exit-active': {
    opacity: 0,
    transform: 'scale(0.8)',
    transition: 'opacity 150ms, transform 150ms',
    transitionDelay: '0',
  },
};
